import { EventAggregator } from 'aurelia-event-aggregator';
import { autoinject, bindable, computedFrom, Disposable } from 'aurelia-framework';
import { AccountListItemVM } from '../account-api';
import { AccountGroupService, IAccountClassAM, IAccountGroupAM } from '../account-group-api';

@autoinject
export class AccountListGroupSelect {
	@bindable account: AccountListItemVM;
	@bindable accountClasses: IAccountClassAM[];
	@bindable onSelected: (params: any) => void;

	selectListOpen = false;
	onBodyClick: (Event) => void;
	dropdownOpenedSubscriber: Disposable;

	dropDownContents: HTMLElement;

	constructor(
		private accountGroupService: AccountGroupService,
		private eventAggregator: EventAggregator) {

		this.onBodyClick = () => { this.close(); };
	}

	@computedFrom('account.accountGroup')
	get selectedAccountGroupId() {
		return this.account.accountGroup != null
			? this.account.accountGroup.id
			: null;
	}

	attached() {
		document.addEventListener('click', this.onBodyClick);

		this.dropdownOpenedSubscriber =
			this.eventAggregator.subscribe('dropdownOpened', (viewModel: any) => {
				if (viewModel !== this) {
					this.close();
				}
			});
	}

	detached() {
		document.removeEventListener('click', this.onBodyClick);
		this.dropdownOpenedSubscriber.dispose();
	}

	onToggleClick(event: Event) {
		event.stopPropagation();
		this.toggleSelectList();

		if (this.selectListOpen) {
			this.dropDownContents.classList.remove('reverse');
			const rect = this.dropDownContents.getBoundingClientRect();
			if(rect.top > document.documentElement.clientHeight / 2) {
				this.dropDownContents.classList.add('reverse');
			} 
			this.eventAggregator.publish('dropdownOpened', this);
		}
	}

	toggleSelectList() {
		this.selectListOpen = !this.selectListOpen;
	}

	select(accountGroup: IAccountGroupAM) {
		const previousAccountGroup = this.account.accountGroup;

		this.account.accountGroup = accountGroup != null
			? {
				id: accountGroup.id,
				nameText: accountGroup.nameText,
				code: accountGroup.code
			}
			: null;

		this.close();
		
		this.accountGroupService.updateAccountGroupOfAccount(
			this.account.id,
			accountGroup != null ? accountGroup.id : null)
			.then((response) => {
				if (response.ok) {
					if (this.onSelected) {
						this.onSelected({ accountGroup });
					}
				} else {
					this.account.accountGroup = previousAccountGroup;
				}
			});
	}

	close() {
		this.selectListOpen = false;
	}
}
